module.exports = __webpack_public_path__ + "static/media/logoPAHT.2b371d32.png";